<template>
  <div>
    <div class="flexbox-container">
      <b-card no-body class="shadow-lg border-10 card-width">
        <b-row no-gutters>
          <b-col class="logo text-center" sm="6 p-5 fundo border-10">
            <b-card-img
              :src="logo"
              alt="Image"
              fluid
              style="max-width: 1200px"
              class="card-img"
            ></b-card-img>
          </b-col>
          <b-col sm="">
            <b-card-body
              :title="$t('Acesso restrito')"
              class="text-center text-secondary"
            >
              <hr style="display: flex" />
              <b-card-text class="text-left padding-40">
                <form>
                  <b-form-group :label="$t('Usuário')" label-for="email">
                    <b-form-input
                      id="email"
                      ref="emailRef"
                      type="email"
                      v-model="email"
                      :state="vemail"
                      required
                      autofocus
                      autocomplete="username"
                    />
                  </b-form-group>
                  <b-form-group :label="$t('Senha')" label-for="password">
                    <b-form-input
                      id="password"
                      ref="passwordRef"
                      type="password"
                      v-model="password"
                      required
                      autocomplete="current-password"
                      :state="nocaps"
                      @keyup="getKey"
                    />
                    <b-form-invalid-feedback id="input-live-feedback">
                      CapsLock {{ $t("ativado") }}!
                    </b-form-invalid-feedback>
                  </b-form-group>

                  <div>&nbsp;</div>

                  <b-button
                    block
                    type="submit"
                    variant="primary"
                    :disabled="!vlogin || busy"
                    @click="loggon"
                  >
                    <b-icon-circle-fill
                      animation="throb"
                      v-if="busy"
                    ></b-icon-circle-fill>
                    {{ $t("Entrar") }}</b-button
                  >
                </form>
              </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { COOKIE_TIMEOUT } from "../../services/config";
import API from "../../services/apiservices";

export default {
  data() {
    return {
      email: "",
      password: "",
      redir: "/home",
      nocaps: null,
      busy: false,
    };
  },

  beforeUpdate() {
    // if (this.$router.history.current.query.redir) {
    // 	this.redir = this.$router.history.current.query.redir;
    // 	this.$root.toastdanger("Necessário efetuar login");
    // }
  },

  computed: {
    vlogin() {
      return this.email !== "" && this.password !== "";
    },
    vemail() {
      return this.email !== "" ? true : null;
    },
    vpassword() {
      return this.password !== "" ? true : null;
    },
    logo() {
      return require("../../assets/Login.svg");
    },
  },

  created() {
    this.redir = this.$route.query.redir || "/";
    this.email =
      localStorage.getItem("lastlogin") !== "undefined"
        ? localStorage.getItem("lastlogin")
        : "";
    this.doInputFocus();

    // API.post(
    //   "https://solucoes.grupok1.com.br/ServerAmbientVariables.asp",
    //   {}
    // ).then((res) => {
    //   console.log("res:", res);
    // });
  },

  methods: {
    getKey(event) {
      this.nocaps =
        event.getModifierState && event.getModifierState("CapsLock")
          ? false
          : this.vpassword
          ? true
          : null;
    },
    doInputFocus() {
      if (this.email && this.email !== "") {
        setTimeout(() => {
          this.$refs.passwordRef.focus();
        }, 300);
      } else {
        setTimeout(() => {
          this.$refs.emailRef.focus();
        }, 300);
      }
    },
    async loggon(e) {
      e.preventDefault();
      this.busy = true;

      if (this.password.length > 0) {
        await API.post("Authentication", {
          User: this.email,
          Password: this.password,
        })
          .then((res) => {
            this.busy = false;
            sessionStorage.setItem("token", res.data.TokenAccess);
            this.$cookies.set("login", this.email, COOKIE_TIMEOUT);
            this.$cookies.set("token", res.data.TokenAccess, COOKIE_TIMEOUT);
            if (
              this.$cookies.get("token") &&
              this.$cookies.get("token") !== ""
            ) {
              this.$emit("loggedIn");
              this.$router.push(this.redir);
            }
            /*
            // API descontinuada //
            API.post("Servicos/Loga/Acesso", {
              SessionId: this.$root.sessionid,
              NomeAplicacao: "Portal Solucoes",
              IP: "solucoes.grupok1.com.br",
              Hostname: "solucoes.grupok1.com.br",
              HTTP_USER_AGENT: navigator.userAgent,
              ScrHeight: window.innerHeight,
              ScrWidth: window.innerWidth,
            });
            */
          })
          .catch((error) => {
            this.busy = false;
            console.error(error);
          });
      }
    },
  },
};
</script>

<style>
#card {
  width: 350px;
  height: 350px;
  display: grid;
  margin-top: 50%;
}
.fundo {
  background: radial-gradient(
    circle,
    rgba(233, 148, 148, 1) 0%,
    rgba(156, 16, 6, 1) 100%
  );
}
.padding-40 {
  padding: 40px;
}
.border-10 {
  border-radius: 10px !important;
}
.border-left10 {
  border-bottom-left-radius: 10px !important;
  border-top-left-radius: 10px !important;
}
.flexbox-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  height: 100vh;
  border-radius: 10px;
}
.card-width {
  max-width: 1000px;
}
@media only screen and (max-width: 600px) {
  .flexbox-container {
    align-items: flex-start;
    margin: 0;
    border-radius: 0;
  }
  .padding-40 {
    padding: 10px;
  }
  .logo > img {
    width: 150px;
  }
}
@media (max-width: 768px) {
  .flexbox-container {
    margin: 0;
    border-radius: 0;
  }
  .card-img {
    height: 285px;
  }
}
@media (max-width: 425px) {
  .flexbox-container {
    margin: 0;
    border-radius: 0;
  }
  .card-img {
    height: 232px;
  }
  .logo {
    height: 240px;
  }
  .logo > img {
    width: 209px;
    height: 140px;
  }
}

@media (max-width: 375px) {
  .flexbox-container {
    margin: 0;
    border-radius: 0;
  }
  .card-img {
    height: 232px;
  }
  .logo {
    height: 222px;
  }
  .logo > img {
    width: 174px;
    height: 122px;
  }
}

@media (max-width: 320px) {
  .flexbox-container {
    margin-top: 95px;
    margin-left: 18px;
    margin-right: 18px;
  }
}
</style>
